import React from 'react'
import PostMetaItem from './PostMetaItem'

export default function BylineItem({ className, item, url, prefix }) {
  return item ? (
    <li className={`byline-item ${className}`}>
      <PostMetaItem url={url} item={item} prefix={prefix} />
    </li>
  ) : null
}
